import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { MOMENT_DATE_FORMAT_STRING } from 'eventbrite_design_system/eventCard/constants';

import moment from 'js-utils/moment';

import { gettext } from '@eb/i18n-ebspa';

import { constants as destinationConstants } from '@eb/destination-utils';
import { CARD_FADE_DELAY, GA_FOLLOW_ORGANIZER_ACTION } from '../constants';

import { getUpcomingEventCopy } from 'consumer-utils/utils';

import FollowCard from './FollowCard';

const { EVENTBRITE_CATEGORY_MAPPING } = destinationConstants;

const SampleEventAttachment = ({ startDate, name }) => (
    <div className="follow-page__follow-card__sample-event eds-l-pad-hor-6 eds-l-pad-vert-4 eds-text-weight--heavy">
        <date className="follow-page__follow-card__sample-event-date">
            {moment(startDate).format(MOMENT_DATE_FORMAT_STRING)}
        </date>
        <div>{name.toLocaleUpperCase()}</div>
    </div>
);

class OrganizerCard extends React.PureComponent {
    static propTypes = {
        organizerId: PropTypes.string.isRequired,
        organizerName: PropTypes.string.isRequired,
        handlePopOrganizer: PropTypes.func.isRequired,
        handleFollowOrganizer: PropTypes.func.isRequired,
        trackGAEvent: PropTypes.func.isRequired,
        isGDPRCountry: PropTypes.bool.isRequired,
        categoryId: PropTypes.string,
        imageUrl: PropTypes.string,
        url: PropTypes.string,
        handleExcludeOrganizer: PropTypes.func,
        handleViewOrganizer: PropTypes.func,
        handleSetError: PropTypes.func,
        type: PropTypes.string,
        label: PropTypes.string,
        userId: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        sampleEvent: PropTypes.object,
        numUpcomingEvents: PropTypes.number,
        launchCommSettingsFollowAction: PropTypes.bool,
        gdprType: PropTypes.oneOf(['organizer', 'collection']),
        showOverlay: PropTypes.func,
        hideOverlay: PropTypes.func,
    };

    static defaultProps = {
        gdprType: 'organizer',
        handleExcludeOrganizer: () => null,
        handleViewOrganizer: () => null,
        handleSetError: () => null,
        type: 'column',
        numUpcomingEvents: 0,
    };

    state = {
        isFollowing: false,
        isClosed: false,
    };

    componentWillUnmount() {
        if (this._followTimeout) {
            clearTimeout(this._followTimeout);
            this._followTimeout = null;
        }

        if (this._closeTimeout) {
            clearTimeout(this._closeTimeout);
            this._closeTimeout = null;
        }
    }

    _handleFollowClick = () => {
        const {
            organizerId,
            handlePopOrganizer,
            handleFollowOrganizer,
            handleSetError,
            trackGAEvent,
            label,
        } = this.props;

        trackGAEvent({
            action: GA_FOLLOW_ORGANIZER_ACTION,
            label,
        });

        this.setState({ isFollowing: true });

        return handleFollowOrganizer(organizerId).then(() => {
            this._followTimeout = setTimeout(() => {
                handlePopOrganizer(organizerId);
            }, CARD_FADE_DELAY);
        }, handleSetError);
    };

    _handleClose = () => {
        const {
            handleExcludeOrganizer,
            handlePopOrganizer,
            organizerId,
        } = this.props;

        handleExcludeOrganizer(organizerId);

        this.setState({ isClosed: true });

        this._closeTimeout = setTimeout(() => {
            handlePopOrganizer(organizerId);
        }, CARD_FADE_DELAY);
    };

    _handleOnClick = () => {
        const { organizerId, handleViewOrganizer } = this.props;

        if (handleViewOrganizer) {
            handleViewOrganizer(organizerId);
        }
    };

    render() {
        const {
            organizerId,
            handleSetError,
            imageUrl,
            isGDPRCountry,
            url,
            userId,
            organizerName,
            categoryId,
            trackGAEvent,
            type,
            sampleEvent,
            numUpcomingEvents,
            launchCommSettingsFollowAction,
        } = this.props;

        const { isFollowing, isClosed } = this.state;

        const containerClasses = classnames({
            'eds-fx--fade-out': isFollowing || isClosed,
        });

        let dataPointOne = null;

        if (numUpcomingEvents) {
            let dataPointText = `${numUpcomingEvents} ${getUpcomingEventCopy(
                numUpcomingEvents,
            )}`;

            if (numUpcomingEvents < 5) {
                const categoryName = EVENTBRITE_CATEGORY_MAPPING[categoryId];

                dataPointText = `${gettext('Popular in')} ${categoryName}`;
            }

            dataPointOne = (
                <div className="follow-card__subtitle-container">
                    <p className="eds-text-bm eds-text-color--ui-500">
                        {dataPointText}
                    </p>
                </div>
            );
        }

        return (
            <div className={containerClasses}>
                <FollowCard
                    id={organizerId}
                    type={type}
                    imageUrl={imageUrl}
                    isFollowing={isFollowing}
                    title={organizerName}
                    url={url}
                    subtitle={dataPointOne}
                    isSquareImage={false}
                    onClose={this._handleClose}
                    onFollow={this._handleFollowClick}
                    onLinkClick={this._handleOnClick}
                    handleSetError={handleSetError}
                    trackGAEvent={trackGAEvent}
                    userId={userId}
                    isGDPRCountry={isGDPRCountry}
                    launchCommSettingsFollowAction={
                        launchCommSettingsFollowAction
                    }
                    gdprType={'organizer'}
                />
                {sampleEvent && (
                    <SampleEventAttachment
                        startDate={sampleEvent.start_date}
                        name={sampleEvent.name}
                    />
                )}
            </div>
        );
    }
}

export default OrganizerCard;
